import {
	LOAD_GUESTS,
  LOAD_GUESTS_SUCCESS,
  LOAD_GUESTS_FAILURE,
	ADD_GUEST,
  ADD_GUEST_SUCCESS,
  ADD_GUEST_FAILURE,
  PUBLIC_ADD_GUEST,
  PUBLIC_ADD_GUEST_SUCCESS,
  PUBLIC_ADD_GUEST_FAILURE,
  REMOVE_GUEST,
  REMOVE_GUEST_SUCCESS,
  REMOVE_GUEST_FAILURE,
  UPDATE_GUEST,
  UPDATE_GUEST_SUCCESS,
  UPDATE_GUEST_FAILURE,
} from '../actions/guests';

const INITIAL_STATE = {guests: [], status: null, error: null, loading: false};

let guestsReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {

  	// ----- Load Guests -----

  	case LOAD_GUESTS:
      return {
        ...state,
        error: null,
        loading: true
      };
    case LOAD_GUESTS_SUCCESS:
      return {
        ...state,
        guests: action.guests,
        error: null,
        loading: false
      };
    case LOAD_GUESTS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

  	// ----- Add Guest -----

  	case ADD_GUEST:
      return {
        ...state,
        error: null,
        loading: true
      };
    case ADD_GUEST_SUCCESS:
    	// add new guest to the top of the list
    	let guests = state.guests.slice();
      guests.unshift(action.guest)
      return {
        ...state,
        guests: guests,
        error: null,
        loading: false
      };
    case ADD_GUEST_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    // ----- Public Add Guest -----

    case PUBLIC_ADD_GUEST:
      return {
        ...state,
        error: null,
        loading: true
      };
    case PUBLIC_ADD_GUEST_SUCCESS:
      // add new guest to the top of the list
      let publicGuests = state.guests.slice();
      publicGuests.unshift(action.guest)
      return {
        ...state,
        guests: publicGuests,
        error: null,
        loading: false
      };
    case PUBLIC_ADD_GUEST_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

  	// ----- Remove Guest -----

  	case REMOVE_GUEST:
      return {
        ...state,
        error: null,
        loading: true
      };
    case REMOVE_GUEST_SUCCESS:
      return {
        ...state,
        guests: state.guests.filter((guest) => {
        	return guest.id !== action.guest.id;
        }),
        error: null,
        loading: false
      };
    case REMOVE_GUEST_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    // ----- Update Guest -----

    case UPDATE_GUEST:
      return {
        ...state,
        error: null,
        loading: true
      };
    case UPDATE_GUEST_SUCCESS:
      return {
        ...state,
        guests: state.guests.map((guest) => {
          if (guest.id === action.guest.id) {
          	return action.guest;
        	} else {
        		return guest;
        	}
        }),
        error: null,
        loading: false
      };
    case UPDATE_GUEST_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export default guestsReducer
